import { render, staticRenderFns } from "./PatternBuilder.vue?vue&type=template&id=8adab53a&scoped=true"
import script from "./PatternBuilder.vue?vue&type=script&lang=ts"
export * from "./PatternBuilder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8adab53a",
  null
  
)

export default component.exports